// composables/useBreadcrumbs.js
export default function () {
  const route = useRoute();
  const { t, locale } = useI18n();

  const breadcrumbs = computed(() => {
    const crumbs = [];
    const paths = route.path.split("/").filter(Boolean).slice(1); // Skip locale

    paths.forEach((path, index) => {
      const fullPath =
        `/${locale.value}/` + paths.slice(0, index + 1).join("/");
      console.log(fullPath);
      // Fallback to formatted path
      const name = path;

      crumbs.push({
        name,
        path: fullPath,
        disabled:
          index === paths.length - 1 && !Object.keys(route.query).length,
      });
    });

    // Process query parameters if they should be shown as breadcrumbs
    if (route.query.active_currency) {
      crumbs.push({
        name: route.query.active_currency,
        path: route.fullPath,
        disabled: true,
        isQueryParam: true,
      });
    }

    return crumbs;
  });

  return { breadcrumbs };
}
